export default __webpack_public_path__ + "static/media/banner.f00ebace.jpeg";